import React, { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import HandleDateTime from "../../../../Common/HandleDateTime";
import {
  deleteVatPeriod,
  deleteVatPeriodSuccess,
  getVatPeriodDetails,
  getVatPeriodList,
} from "../../../../../store/generalSettings/action";
import DeleteModal from "../../../../Common/DeleteModal";
import CreateEditPeriod from "../../../../popUpComponents/CreateEditPeriod";
import TableContainer from "../../../../Common/TableContainer";
import {
  deleteYearEndPeriod,
  deleteYearEndPeriodSuccess,
  getYearEndPeriodDetails,
  getYearEndPeriodList,
} from "../../../../../store/YearEndPeriod/action";
import { useHistory } from "react-router-dom";

export default function PeriodReports({ page, data, reportName, tab }) {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <span className={"like-href"}> #{card.row.original.Id}</span>
              </div>
            </div>
          </>
        ),
      },
      {
        // job id  with beginning #Job_Id
        Header: "Locked Users",
        accessor: "FlagLockedUsers",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 name">
                {card.row.original?.FlagLockedUsers === "1" ? (
                  <div className={"text-danger"}>
                    <i className="fa-solid fa-lock me-1"></i>
                    <span>Locked</span>
                  </div>
                ) : (
                  <div className={"text-success"}>
                    <i className="fa-solid fa-lock-open me-1"></i>
                    <span>Open</span>
                  </div>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        // job id  with beginning #Job_Id
        Header: "Locked Advisors",
        accessor: "FlagLockedAdvisors",
        filterable: false,
        Cell: (card) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 name">
                {card.row.original?.FlagLockedAdvisors === "1" ? (
                  <div className={"text-danger"}>
                    <i className="fa-solid fa-lock me-1"></i>
                    <span>Locked</span>
                  </div>
                ) : (
                  <div className={"text-success"}>
                    <i className="fa-solid fa-lock-open me-1"></i>
                    <span>Open</span>
                  </div>
                )}
              </div>
            </div>
          </>
        ),
      },

      {
        Header: "Start Date",
        accessor: "StartDate",
        Cell: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row.row.original?.StartDate)}</div>;

          // return row.CreatedDateTime
        },
        filterable: true,
      },
      {
        Header: "End Date",
        accessor: "EndDate",
        Cell: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row.row.original?.EndDate)}</div>;

          // return row.CreatedDateTime
        },
        filterable: true,
      },
      // Notes
      {
        Header: "Notes",
        accessor: "Notes",
        Cell: (row) => {
          return <div>{row.row.original?.Notes}</div>;
        },
      },
      //action edit delete
      {
        Header: "Action",
        accessor: "action",
        Cell: (row) => {
          return (
            <div>
              <UncontrolledDropdown>
                <DropdownToggle
                  className="btn btn-soft-info btn-icon fs-14"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fa-solid fa-ellipsis"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <li>
                    <DropdownItem>
                      <div
                        className="edit-item-btn"
                        onClick={() => {
                          handleGetVatPeriodDetails(row.row.original?.Id);
                        }}
                      >
                        <div className={"job-settings-buttons"}>
                          <i className="ri-pencil-fill align-center text-muted"></i>
                          <span> Edit</span>
                        </div>
                      </div>
                    </DropdownItem>
                  </li>

                  <li>
                    <DropdownItem>
                      <div
                        className="remove-item-btn"
                        onClick={() => {
                          setSelectForDelete([row.row.original?.Id]);
                          setDeleteModal(true);
                        }}
                      >
                        <div className={"job-settings-buttons"}>
                          <i className="ri-delete-bin-fill align-center text-muted"></i>{" "}
                          <span> Delete</span>
                        </div>
                      </div>
                    </DropdownItem>
                  </li>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        },
      },
    ],
    []
  );
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "Notes",
  ]);
  useEffect(() => {
    let filteredCustomerList = data;

    const timer = setTimeout(() => {
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters?.some((key) => {
          return (
            item[key] &&
            item[key]
              ?.toString()
              ?.toLowerCase()
              ?.includes(search?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, data]);

  const [modalAddEditPeriod, setModalAddEditPeriod] = useState(false);
  const toggleAddEditVATPeriod = () =>
    setModalAddEditPeriod(!modalAddEditPeriod);

  const [isEdit, setIsEdit] = useState(false);
  const handleCreateEditVATPeriod = (type) => {
    if (type === "create") {
      setIsEdit(false);
    } else {
      setIsEdit(true);
    }
    toggleAddEditVATPeriod();
  };
  const handleGetVatPeriodDetails = (id) => {
    switch (reportName) {
      case "vatPeriod":
        dispatch(getVatPeriodDetails({ id }));
        handleCreateEditVATPeriod("edit");
        break;
      case "yearEndPeriod":
        dispatch(getYearEndPeriodDetails({ id }));
        handleCreateEditVATPeriod("edit");
        break;
      default:
        break;
    }
  };
  const { vatPeriodDetailsAPI } = useSelector((state) => ({
    vatPeriodDetailsAPI: state.GeneralSettings.vatPeriodDetails?.vatperiod_data,
  }));
  const { yearEndPeriodDetailsAPI } = useSelector((state) => ({
    yearEndPeriodDetailsAPI:
      state.YearEndPeriod.yearEndPeriodDetails?.yearendperiod_data,
  }));

  const [selectForDelete, setSelectForDelete] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDeleteVatPeriod = () => {
    switch (reportName) {
      case "vatPeriod":
        dispatch(deleteVatPeriod(selectForDelete));
        break;
      case "yearEndPeriod":
        dispatch(deleteYearEndPeriod(selectForDelete));
        break;
      default:
    }
  };
  const { deleteVatPeriodSuccessAPI } = useSelector((state) => ({
    deleteVatPeriodSuccessAPI: state.GeneralSettings.deleteVatPeriodSuccess,
  }));
  const { deleteYearEndPeriodSuccessAPI } = useSelector((state) => ({
    deleteYearEndPeriodSuccessAPI:
      state.YearEndPeriod.deleteYearEndPeriodSuccess,
  }));
  useEffect(() => {
    if (isEmpty(deleteVatPeriodSuccessAPI)) return;
    if (deleteVatPeriodSuccessAPI?.status === 200) {
      toast.success(deleteVatPeriodSuccessAPI?.message);
      dispatch(getVatPeriodList());
      setDeleteModal(false);
    } else {
      toast.error(deleteVatPeriodSuccessAPI?.message);
    }
    dispatch(deleteVatPeriodSuccess([]));
  }, [deleteVatPeriodSuccessAPI]);

  useEffect(() => {
    if (isEmpty(deleteYearEndPeriodSuccessAPI)) return;
    if (deleteYearEndPeriodSuccessAPI?.status === 200) {
      toast.success(deleteYearEndPeriodSuccessAPI?.message);
      dispatch(getYearEndPeriodList());
      setDeleteModal(false);
    } else {
      toast.error(deleteYearEndPeriodSuccessAPI?.message);
    }
    dispatch(deleteYearEndPeriodSuccess([]));
  }, [deleteYearEndPeriodSuccessAPI]);

  const handlePeriodDetails = () => {
    switch (reportName) {
      case "vatPeriod":
        return vatPeriodDetailsAPI;
      case "yearEndPeriod":
        return yearEndPeriodDetailsAPI;
      default:
        break;
    }
  };
  const history = useHistory();
  return (
    <>
      <DeleteModal
        show={deleteModal}
        onCloseClick={() => {
          setDeleteModal(false);
        }}
        onDeleteClick={() => {
          handleDeleteVatPeriod();
        }}
        customText={"Are you sure you want to delete this VAT Period?"}
        customButtonText={"Yes, Delete It!"}
      />
      {modalAddEditPeriod && (
        <CreateEditPeriod
          modal={modalAddEditPeriod}
          setModal={setModalAddEditPeriod}
          toggle={toggleAddEditVATPeriod}
          isEdit={isEdit}
          periodDetails={handlePeriodDetails()}
          reportName={reportName}
        />
      )}
      <div className={"p-2 m-2"}>
        <Row className="g-4 align-items-center">
          <Col sm={3}>
            <div className="search-box">
              <Input
                // create search with jobs List Data
                type="search"
                className="form-control search"
                placeholder="Search for..."
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                value={search}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>
          <div className="col-sm-auto ms-auto">
            <div className="hstack gap-2">
              {tab === "vatPeriod" && (
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    history.push("/vat-period-export");
                  }}
                >
                  <i className="ri-add-line align-bottom me-1"></i>
                  Export Period
                </button>
              )}

              <button
                className="btn btn-success"
                onClick={() => {
                  handleCreateEditVATPeriod("create");
                }}
              >
                <i className="ri-add-line align-bottom me-1"></i>
                Add new Period
              </button>
            </div>
          </div>
        </Row>
        <div>
          <TableContainer
            columns={columns}
            data={searchResults || []}
            isGlobalFilter={false}
            isAddUserList={false}
            customPageSize={10}
            className="custom-header-css"
            divClass="table-responsive table-card mb-0"
            tableClass="align-middle table-nowrap"
            theadClass="text-muted"
            // handleLeadClick={handleLeadClicks}
            isLeadsFilter={false}
          />
        </div>
      </div>
    </>
  );
}
